export type CheckboxProps = {
  label?: string;
  id?: string;
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  value?: string | number | readonly string[];
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function Checkbox({
  label,
  id,
  className,
  checked,
  value,
  disabled,
  onChange,
}: CheckboxProps) {
  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        value={value}
        id={id}
        className={
          className
            ? className
            : "w-4 h-4 text-primary bg-gray-100 border-gray-300 rounded focus:ring-primary dark:focus:ring-primary dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
        }
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      {label && (
        <label
          htmlFor={id}
          className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
        >
          {label}
        </label>
      )}
    </div>
  );
}
